import { leadVerificationEndpoint } from '../data/tally'

const SID_PATTERN = /^[A-Za-z0-9]{4,20}$/
const SENT_KEY = 'jseefect-lead-sids'

export type VerificationResult = 'valid' | 'invalid' | 'unconfigured' | 'error'

export function isWellFormedSid(sid: string | null): sid is string {
  return Boolean(sid && SID_PATTERN.test(sid))
}

/** Pregunta al servicio de verificación si el envío existe en Tally y es reciente. */
export async function verifyTallySubmission(sid: string): Promise<VerificationResult> {
  if (!leadVerificationEndpoint) return 'unconfigured'
  try {
    const base = leadVerificationEndpoint.replace(/\/+$/, '')
    const url = `${base}/?sid=${encodeURIComponent(sid)}`
    const res = await fetch(url, { method: 'GET', credentials: 'omit', cache: 'no-store' })
    if (!res.ok) return 'error'
    const data: unknown = await res.json()
    const valid = typeof data === 'object' && data !== null && (data as { valid?: unknown }).valid === true
    return valid ? 'valid' : 'invalid'
  } catch {
    return 'error'
  }
}

export function wasLeadAlreadySent(sid: string): boolean {
  try {
    const list: unknown = JSON.parse(window.localStorage.getItem(SENT_KEY) ?? '[]')
    return Array.isArray(list) && list.includes(sid)
  } catch {
    return false
  }
}

export function markLeadSent(sid: string) {
  try {
    const raw: unknown = JSON.parse(window.localStorage.getItem(SENT_KEY) ?? '[]')
    const list = Array.isArray(raw) ? (raw as string[]) : []
    window.localStorage.setItem(SENT_KEY, JSON.stringify([...list.slice(-19), sid]))
  } catch {
    // Si el almacenamiento no está disponible, Meta igual deduplica por eventID.
  }
}
